@import '../../styles/modals.css';
@import '../../styles/buttons.css';
@import '../../styles/skeleton.css';


#tambr-payment-method-add .card-info { width: 100%; display: flex; justify-content: space-between; }

#tambr-payment-method-add .StripeElement {
  box-sizing: border-box;
  padding: 10px;
  margin: 0 0 15px;
  width: 100%;
  color: #32325d;
  background-color: white;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 #e6ebf1;
}

#tambr-payment-method-add .StripeElement--invalid { border: 1px solid red; }
.tambr-payment-method-add-error { color: #ff0000; }

#tambr-payment-method-add .card-info .StripeElement,
#tambr-payment-method-add .card-info .skeleton-text { width: calc(50% - 10px); }

#tambr-payment-method-add-setup-form { padding: 25px 15px; }

#tambr-payment-method-add-setup-form-elements-wrapper { position: relative; min-height: 50px; }

#tambr-payment-method-add-setup-form-elements-preloader {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  background: #F8F9FA;
  width: 100%;
  visibility: hidden;
}

#tambr-payment-method-add-setup-form-elements-preloader.visible { visibility: visible; }

#tambr-payment-method-add-setup-form-elements-preloader .skeleton-text {
  width: 100%;
  height: 38px;
  margin: 0 0 15px;
}